export type Environment = "prod" | "stage" | "dev";
const baseUrl: string = window.location.hostname;
// TODO: add prod url
const isProd = baseUrl === "coworker.ingka.com";
const isDev = baseUrl.includes("dev");
const isStage = baseUrl.includes("stage");
const isLocal = !isProd && !isStage && !isDev;

export const environment = {
  isProd,
  isStage,
  isLocal,
};
